import React, { createContext, useContext, useEffect, useState } from "react";
import { t } from "../lib/translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "mc_lang";

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  }, [lang]);

  const value = {
    lang,
    setLang,
    isGu: lang === "gu",
    t: (key, vars) => t(lang, key, vars),
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
